

import { pricingConfig } from "@/hooks/subscription/types";

interface PricingHeaderProps {
  billingPeriod: "monthly" | "yearly";
  toggleBillingPeriod: () => void;
}

const PricingHeader = ({ billingPeriod, toggleBillingPeriod }: PricingHeaderProps) => {
  const savingsPercentage = pricingConfig.annual.savingsPercentage;
  
  return (
    <>
      <h2 className="text-3xl sm:text-4xl font-bold mb-3 sm:mb-4">Pricing</h2>
      <p className="text-base sm:text-lg text-neutral-600 mb-5 sm:mb-8">
        You're not just logging moves. You're building a relationship with the art.
      </p>
      <p className="text-neutral-600 text-sm sm:text-base max-w-3xl mx-auto">
        This is a tool built by a team who's been there — through the plateaus, the injuries, the
        breakthroughs. It's for people who care about their Jiu Jitsu journey.
      </p>
      
      <div className="flex items-center justify-center mt-6 sm:mt-8 mb-4 space-x-2 sm:space-x-3">
        <div className="flex items-center bg-neutral-100 p-1.5 rounded-full border border-neutral-300 shadow-sm">
          <span className={`px-3 sm:px-4 py-1.5 rounded-full font-medium transition-colors text-sm sm:text-base ${
            billingPeriod === "monthly" 
              ? "bg-white text-black shadow-sm" 
              : "text-neutral-500 hover:text-neutral-700"
          }`}>
            Monthly
          </span>
          
          <button
            onClick={toggleBillingPeriod}
            className="relative inline-flex h-6 sm:h-7 w-12 sm:w-14 items-center rounded-full bg-neutral-200 mx-2 border border-neutral-300"
            aria-pressed={billingPeriod === "yearly"}
            role="switch"
          >
            <span className="sr-only">Toggle billing period</span>
            <span
              className={`inline-block h-4 sm:h-5 w-4 sm:w-5 transform rounded-full bg-white shadow-md transition-transform border border-neutral-300 ${
                billingPeriod === "yearly" ? "translate-x-7 sm:translate-x-8" : "translate-x-1"
              }`}
            />
          </button>
          
          <div className="relative">
            <span className={`px-3 sm:px-4 py-1.5 rounded-full font-medium transition-colors text-sm sm:text-base ${
              billingPeriod === "yearly" 
                ? "bg-white text-black shadow-sm" 
                : "text-neutral-500 hover:text-neutral-700"
            }`}>
              Yearly
            </span>
            {billingPeriod === "monthly" && (
              <span className="absolute -top-4 -right-2 text-xs font-medium text-green-600 bg-green-100 px-2 py-0.5 rounded-full">
                Save {savingsPercentage}%
              </span>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default PricingHeader;
